"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutableReference = void 0;
const MutableObject_1 = require("../model/MutableObject");
const MutationOp_1 = require("../model/MutationOp");
const HashedObject_1 = require("../model/HashedObject");
const timestamps_1 = require("../../util/timestamps");
const Types_1 = require("./Types");
class MutableReference extends MutableObject_1.MutableObject {
    constructor() {
        super([RefUpdateOp.className]);
        this.setRandomId();
    }
    getValue() {
        return this._value;
    }
    async setValue(value) {
        let op = new RefUpdateOp(this, value, this._sequence);
        await this.applyNewOp(op);
    }
    async mutate(op, _isNew) {
        let refUpdateOp = op;
        let mutated = false;
        if (refUpdateOp.getTarget().equals(this)) {
            if (this._sequence === undefined ||
                this._sequence < refUpdateOp.getSequence() ||
                (this._sequence === refUpdateOp.getSequence() &&
                    timestamps_1.Timestamps.after(refUpdateOp.getTimestamp(), this._timestamp))) {
                this._sequence = refUpdateOp.getSequence();
                this._timestamp = refUpdateOp.getTimestamp();
                this._value = refUpdateOp.getValue();
                mutated = true;
            }
        }
        return mutated;
    }
    getClassName() {
        return MutableReference.className;
    }
    init() {
    }
    async validate(references) {
        references;
        return Types_1.Types.isTypeConstraint(this.typeConstraints);
    }
}
exports.MutableReference = MutableReference;
MutableReference.className = 'hhs/v0/MutableReference';
class RefUpdateOp extends MutationOp_1.MutationOp {
    constructor(target, value, sequence) {
        super(target);
        if (target !== undefined) {
            this.value = value;
            this.sequence = sequence === undefined ? 0 : sequence + 1;
            this.timestamp = timestamps_1.Timestamps.uniqueTimestamp();
        }
    }
    getClassName() {
        return RefUpdateOp.className;
    }
    init() {
    }
    async validate(references) {
        var _a;
        if (!super.validate(references)) {
            return false;
        }
        if (this.getTarget().getAuthor() !== undefined && !((_a = this.getTarget().getAuthor()) === null || _a === void 0 ? void 0 : _a.equals(this.getAuthor()))) {
            return false;
            //throw new Error('RefUpdateOp has author ' + this.getAuthor()?.hash() + ' but points to a target authored by ' + this.getTarget().getAuthor()?.hash() + '.');
        }
        if (this.sequence === undefined) {
            return false;
            //throw new Error('The field sequence is mandatory in class RefUpdateOp');
        }
        if ((typeof this.sequence) !== 'number') {
            return false;
            //throw new Error('The field sequence should be of type number in class RefUpdateop');
        }
        if (this.timestamp === undefined) {
            return false;
            //throw new Error('The field timestamp is mandatory in class RefUpdateOp');
        }
        if ((typeof this.timestamp) !== 'string') {
            return false;
            //throw new Error('The field timestamp should be of type timestamp in class RefUpdateop');
        }
        if (this.value === undefined) {
            return false;
            //throw new Error('The field value is mandatory in class REfUpdateop');
        }
        if (this.target === undefined ||
            this.target.getClassName() !== MutableReference.className) {
            return false;
            //throw new Error('A RefUpdateOp can only have a MutableReference as its target.');
        }
        let constraints = this.target.typeConstraints;
        if (!Types_1.Types.satisfies(this.value, constraints)) {
            return false;
            //throw new Error('RefUpdateOp contains a value with an unexpected type.')
        }
        return true;
    }
    getSequence() {
        return this.sequence;
    }
    getTimestamp() {
        return this.timestamp;
    }
    getValue() {
        return this.value;
    }
}
RefUpdateOp.className = 'hhs/v0/RefUpdateOp';
HashedObject_1.HashedObject.registerClass(MutableReference.className, MutableReference);
HashedObject_1.HashedObject.registerClass(RefUpdateOp.className, RefUpdateOp);
//# sourceMappingURL=MutableReference.js.map